var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnapprovedQuotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#FFE1DF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32 14C41.9411 14 50 22.0589 50 32C50 41.9411 41.9411 50 32 50C22.0589 50 14 41.9411 14 32C14 22.0589 22.0589 14 32 14ZM43.6149 22.5064L22.5064 43.6149C28.3984 48.4426 37.1067 48.1065 42.6066 42.6066C48.1065 37.1067 48.4426 28.3985 43.6149 22.5064ZM20.3851 41.4936L41.4936 20.3851C35.6015 15.5574 26.8933 15.8935 21.3934 21.3934C15.8935 26.8933 15.5574 35.6015 20.3851 41.4936Z",
    fill: "#F1373A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnapprovedQuotes);
export default __webpack_public_path__ + "static/media/unapprovedQuotes.b693be3d5b44cbc3abecc8fbf602f3c3.svg";
export { ForwardRef as ReactComponent };